var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/step-up-answer-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-07af6200!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/step-up-answer-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/StepUpAnswerList.vue
// module id = 1361
// module chunks = 1